import { Injectable} from '@angular/core';
import {  Router, ActivatedRoute } from '@angular/router';
import { User } from '../../modals/user';
import { Token } from '../../modals/token';
import {ApiEndpoints} from '../shared/services/ApiEndpoints';
import {ApiUtils} from '../shared/services/ApiUtils';
import { plainToClass } from 'class-transformer';
// import { SharedMethods } from '../util/sharedMethods-service';
import {HttpClient} from '@angular/common/http';
import { Subject } from 'rxjs';
import { SharedMethods } from '../shared/services/sharedMethods-service';
import { CartService } from '../shared/services/cart.service';


// const MINUTES_UNITL_AUTO_LOGOUT = 15 ; // in mins
const CHECK_INTERVAL = 15000; // in ms
const STORE_KEY =  'lastAction';

@Injectable()
export class AuthService {

  private _token: Token;

  redirect = 'pages/dashbord';

  isLoginPage = false;

  permissionsToRedirect: string[];

  isTenanTDBChange = false;

  credentiales: {
      login: string,
      password: string,
  };

  logoutEvent = new Subject<any>();

  loginEvent = new Subject<any>();

  constructor(private router: Router, public apiEndpoints: ApiEndpoints, public http: HttpClient,
    public apiUtils: ApiUtils, public sharedMethods: SharedMethods, private cartService: CartService
    // public networkService:NetworkService,
    // public sharedMethods: SharedMethods,
    ) {

    if (localStorage.getItem('bessalel_store_token') !== null && this.isTimeout)
    this._token = plainToClass(Token, JSON.parse(localStorage.getItem('bessalel_store_token')) as object);
    // this.token = JSON.parse(localStorage.getItem('bessalel_store_token'));

  }

  get token() {

    return this._token;
  }

  set token(tok: Token) {

    this._token = tok;

    localStorage.setItem('bessalel_store_token', JSON.stringify(tok));

  }

  public checkinterval(): number {

    return CHECK_INTERVAL;
  }
  public storekey(): string {

    return STORE_KEY;
  }

  public getLastAction() {
    // tslint:disable-next-line:radix
    return parseInt(localStorage.getItem(STORE_KEY));
  }

  public setLastAction(lastAction: number) {
    localStorage.setItem(STORE_KEY, lastAction.toString());
  }

  isTimeout(): boolean {
    const now = Date.now();

    let timeleft: number;

    // tslint:disable-next-line:max-line-length
    if ( this.token !== null && this.token !== undefined && this.token.company.logout_times !== null && this.token.company.logout_times !== undefined)
    timeleft = this.getLastAction() + this.token.company.logout_times * 60 * 1000;
    else
    timeleft = this.getLastAction() + 15 * 60 * 1000;

    const diff = timeleft - now;
    const timeout = diff < 0;
    return timeout;

  }

  authenticate() {


    const cred = {
        login: this.credentiales.login,
        password: this.credentiales.password,
    };

    // this.apiUtils.TENANTDB = this.credentiales.tenant;

    return this.http.post(this.apiEndpoints.GET_URL_LOGIN, cred, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});


  }

  socialAuthenticate(name: string, email: string) {

    // this.apiUtils.TENANTDB = this.credentiales.tenant;

    return this.http.get(this.apiEndpoints.GET_URL_SOCIALLOGIN(name, email), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});


  }

  forgetPass() {

    // tslint:disable-next-line:max-line-length
    return this.http.get(this.apiEndpoints.GET_URL_FORGETPASS(this.credentiales.login), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }

  changePass(code: string, newpassword: string) {

    // tslint:disable-next-line:max-line-length
    return this.http.get(this.apiEndpoints.GET_URL_CHANGEPASS(code, newpassword), {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

  }

  login(affiliate?) {

    this.loginEvent.next('login');

    /* if(this.redirect !== undefined && this.redirect !== '')
    this.router.navigate([this.redirect]); */

    if(affiliate === undefined || affiliate === false)
    window.location.href = this.redirect;
    // this.router.navigate([this.redirect]);


    /* if ( this.isHavingPermission(this.permissionsToRedirect) ) {

      window.location.href = '#' + this.redirect;
      this.isLoginPage = false;

      if (this.isTenanTDBChange)
      window.location.reload();

    } else {


      window.location.href = '#';
      this.isLoginPage = false;

      if (this.isTenanTDBChange)
      window.location.reload();

    } */

    // this.isAuthenticating = false;

  }

  logout() {

    // s'il s'agit d'une fenetre popup on la laisse connecter car sera fermé par la fenetre principale
    // Et on oubli pas de supprimer le localStorage de popup à la fin
    /* if (this.fenetreService.findnames(window.name) !== null )
    return; */

    localStorage.removeItem('bessalel_store_token');
    this.token = null;

    // localStorage.removeItem('tenant');
    // this.apiUtils.TENANTDB = '';

    // localStorage.removeItem('popup');

    // tslint:disable-next-line:no-console
    // console.log(this.permissionsToRedirect);

    this.logoutEvent.next('logout');
    // mettre this.router.navigate(['/home/index']) au lieu this.router.navigate(['']); pour ne pas faire disparaître le header
    this.router.navigate(['/home/index']);

  }

  isHavingPermission(permission: string[]): boolean {

    const result = false;

    if (permission === undefined )
    return true;

    return result;

  }

  get companyName(): string {

    // tslint:disable-next-line:max-line-length
    if (this.token !== null && this.token !== undefined && this.token.company !== undefined && this.token.company !== null && this.token.company.name !== undefined)
    return this.token.company.name;
    else
    return '';

  }

  get companyAdress(): string {

    if (this.token !== null && this.token !== undefined && this.token.company !== undefined && this.token.company !== null ) {

      let local = '';
      if (this.token.company.rue !== null && this.token.company.rue !== undefined)
      local += this.token.company.rue;

      if (this.token.company.quatier !== null && this.token.company.quatier !== undefined) {
          if (local !== '')
          local += ' - ' + this.token.company.quatier;
          else
          local += this.token.company.quatier;
      }

      if (this.token.company.ville !== null && this.token.company.ville !== undefined) {
          if (local !== '')
          local += ', ' + this.token.company.ville;
          else
          local +=  this.token.company.ville;
      }

      if (this.token.company.pays !== null && this.token.company.pays !== undefined) {

          if (local !== '')
          local += ', ' + this.token.company.pays;
          else
          local +=  this.token.company.pays;

      }

      return local;

    } else
    return '';

  }

  get companyEmail(): string {

    // tslint:disable-next-line:max-line-length
    if (this.token !== null && this.token !== undefined && this.token.company !== undefined && this.token.company !== null && this.token.company.email !== undefined)
    return this.token.company.email;
    else
    return '';

  }

  get companyDescription(): string {

    // tslint:disable-next-line:max-line-length
    if (this.token !== null && this.token !== undefined && this.token.company !== undefined && this.token.company !== null && this.token.company.description_entreprise !== null)
    return this.token.company.description_entreprise;
    else
    return '';

  }

  get companyContact(): string {

    // tslint:disable-next-line:max-line-length
    if (this.token !== null && this.token !== undefined && this.token.company !== undefined && this.token.company !== null && this.token.company.contact !== undefined)
    return this.token.company.contact;
    else
    return '';

  }

  get formatDateClotureOp(): string {

      if (this.token.company.date_cloture_op !== null && this.token.company.date_cloture_op !== undefined) {
        const tab = this.token.company.date_cloture_op.split('-');
        return  tab[2] + '/' + tab[1] + '/' + tab[0];
        // return new Date(date).toISOString;
      } else {
        return '';
      }

  }

  getUserByid(id) {

    return this.http.get(this.apiEndpoints.GET_URL_GET_USERS(id), {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});

  }

  createUser(userForRegistration: User) {

    const user = userForRegistration;

    let userdata: any;

    if (user.password !== undefined && user.password !== null && user.password !== '') {

      userdata = {
        name: user.name,
        username: user.username,
        email: user.email,
        // roles: user.roles,
        isActive: user.is_active,
        plainPassword: user.password,
        companyId: 1,
      };

    } else { // ce different les deux est l'envoie du mot de passe pour la creation

      userdata = {
        name: user.name,
        username: user.username,
        email: user.email,
        // roles: user.roles,
        isActive: user.is_active,
        companyId: 1,
      };

    }


    if (user.id !== 0) {

        // tslint:disable-next-line:max-line-length
        return this.http.patch(this.apiEndpoints.GET_URL_PATCH_USERS(user.id), userdata, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()})

    } else {

        return  this.http.post(this.apiEndpoints.GET_URL_POST_USERS(), userdata, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()})

    }



  }


  updateUser(userForRegistration: User) {

    const user = userForRegistration;

    let userdata: any;

      userdata = {
        name: user.name,
        username: user.username,
        email: user.email,
        // roles: user.roles,
        isActive: user.is_active,
        companyId: 1,
        tel: user.tel,
        pays: user.pays,
        ville: user.ville,
        adresse: user.adresse,
        bp: user.bp,
        civility: user.civility,
        newPassword: user.newpassword,
        plainPassword: user.password,
        isStorespace: user.is_storespace,
        storename: user.storename
      };


      // tslint:disable-next-line:max-line-length
      return this.http.patch(this.apiEndpoints.GET_URL_PATCH_USERS(user.id), userdata, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});


  }



}
